import { useColorMode } from '@xstyled/styled-components'
import logoLight from '../../images/logo-manifest.png'
import logoDark from '../../images/logo-manifest-dark.png'

export const PngLogoByMode = () => {
  const [mode] = useColorMode()
  let retVal = logoLight
  if (mode === 'dark') {
    retVal = logoDark
  }
  return retVal
}

export const LogoWrapper = ({ children }) => {
  const source = PngLogoByMode()
  const childrenCopy = { ...children }
  childrenCopy.props = { ...childrenCopy.props, src: source }
  return childrenCopy
}
